import { Button, Checkbox, Tooltip } from 'antd';
import React, { useState } from 'react';
import catchError from '../../utils/catchError';
import doAxiosRequest from '../../utils/doAxiosRequest';
import { useStateValue } from '../../providers/StateProvider';

const AvisoAuditor = () => {
    const [{ token }, dispatch] = useStateValue();
    const [isFirstSelected, setIsFirstSelected] = useState(false);
    const [isSecondSelected, setIsSecondSelected] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleSelectFirst = ({ target: { checked } }) => {
        setIsFirstSelected(checked);
    };

    const handleSelectSecond = ({ target: { checked } }) => {
        setIsSecondSelected(checked);
    };

    const handleSave = catchError(async () => {
        const { ok } = await doAxiosRequest(
            '/general/general/avisoPrivacidad',
            'POST',
            token,
            dispatch,
            { },
            setLoading,
        );
        if (ok) {
            dispatch({ type: 'SET_AVISO_PRIVACIDAD' });
            localStorage.removeItem('avisoPrivacidad');
        }
    });
    return (
        <div className="d-flex flex-column h-100">
            <Checkbox onChange={handleSelectFirst} style={{ fontSize: '25px', margin: '10px' }}>
                Confirmo que he leído el
                {' '}
                <a href="https://ease.gob.mx/assets/pdf/AVISODEPRIVACIDADINTEGRALYSIMPLIFICADOADMINYFINANZAS.pdf" target="_blank" rel="noreferrer">aviso de privacidad de recursos humanos.</a>
            </Checkbox>
            <Checkbox onChange={handleSelectSecond} style={{ fontSize: '25px', margin: '10px' }}>
                Confirmo que he leído el
                {' '}
                <a href="https://ease.gob.mx/assets/pdf/AVISODEPRIVACIDADINTEGRALYSIMPLIFICADODECLARACIONPATRIMONIAL.pdf" target="_blank" rel="noreferrer">aviso de privacidad de declaración patrimonial.</a>
            </Checkbox>
            <div>
                <Tooltip title={(!isFirstSelected || !isSecondSelected) ? 'Para continuar debe aceptar ambos avisos de privacidad.' : ''}>
                    <Button
                        loading={loading}
                        disabled={!isFirstSelected || !isSecondSelected}
                        type="primary"
                        style={{ margin: '10px', width: '120px' }}
                        onClick={handleSave}
                    >
                        Continuar
                    </Button>
                </Tooltip>
            </div>
        </div>
    );
};

export default AvisoAuditor;
